import { fromPromise as _fromPromise } from 'rxjs/observable/fromPromise';
import { empty as _empty } from 'rxjs/observable/empty';
import { of as _of } from 'rxjs/observable/of';
export const fromPromise = _fromPromise;
export const empty = _empty;
export const of = _of;